'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaymentsForFeisAccount = function () {
  function PaymentsForFeisAccount(svc, aid, fid) {
    _classCallCheck(this, PaymentsForFeisAccount);

    this._svc = svc;
    this._acct_id = aid;
    this._feis_id = fid;
    this._base_url = IFEIS_API_URI + '/api/feiseanna/' + fid + '/accounts/' + aid;
  }

  _createClass(PaymentsForFeisAccount, [{
    key: 'debits',
    value: function debits() {
      return this._svc.$http.get(this._base_url + '/debits');
    }
  }, {
    key: 'credits',
    value: function credits() {
      return this._svc.$http.get(this._base_url + '/credits');
    }
  }, {
    key: 'cart',
    value: function cart() {
      return this._svc.$http.get(this._base_url + '/cart');
    }
  }, {
    key: 'balance',
    value: function balance() {
      return this._svc.$http.get(this._base_url + '/balance');
    }
  }, {
    key: 'credit',
    value: function credit(amount, stripe_token, description, currency, toBeChargedAccounts) {
      return this._svc.$http.post(this._base_url + '/credits', {
        amount: amount,
        description: description,
        stripe_token: stripe_token,
        currency: currency,
        toBeChargedAccounts: toBeChargedAccounts

      });
    }
  }]);

  return PaymentsForFeisAccount;
}();

var PaymentsForAccount = function () {
  function PaymentsForAccount(svc, aid) {
    _classCallCheck(this, PaymentsForAccount);

    this._svc = svc;
    this.id = aid;
  }

  _createClass(PaymentsForAccount, [{
    key: 'forFeis',
    value: function forFeis(fid) {
      return new PaymentsForFeisAccount(this._svc, this.id, fid);
    }
  }]);

  return PaymentsForAccount;
}();

var Payments = function () {
  function Payments($http) {
    _classCallCheck(this, Payments);

    this._svc = { $http: $http };
  }

  _createClass(Payments, [{
    key: 'forAccount',
    value: function forAccount(aid) {
      return new PaymentsForAccount(this._svc, aid);
    }
  }]);

  return Payments;
}();

exports.default = angular.module('ifeis.payments', []).service('fPaymentsService', Payments);


//////////////////
// WEBPACK FOOTER
// ./payments/index.js
// module id = 141
// module chunks = 0